if (typeof TPS == "undefined" || !TPS) {
    var TPS = {};
}

TPS.EAP = {
    formWrapper: null,
    formSubmittedWrapper: null,
    inputs: {},
    eapReasonSelector: null,
    btnSubmit: null,

    init: function () {

        this.formWrapper = document.getElementById('eapForm');
        this.formSubmittedWrapper = document.getElementById('eapFormSubmitted');
        this.inputs.firstName = document.getElementById('eapFirstName');
        this.inputs.lastName = document.getElementById('eapLastName');
        this.inputs.streetAddress = document.getElementById('eapStreetAddress');
        this.inputs.city = document.getElementById('eapCity');
        this.inputs.state = document.getElementById('eapState');
        this.inputs.country = document.getElementById('eapCountry');
        this.inputs.zipcode = document.getElementById('eapZipcode');
        this.inputs.email = document.getElementById('eapEmail');
        this.inputs.phone = document.getElementById('eapPhone');
        this.inputs.reason = document.getElementById('eapReason');

        this.eapReasonSelector = document.getElementById('eapReasonSelector');


        this.btnSubmit = document.getElementById('eapSubmitBtn');

        TPS.Util.loadWebserviceJS('CMSApp.AV.API.Pin');
        this.populateStateDropdown();

        TPS.Forms.setupClientValidation('#eapForm');

        this.setEvent_ReasonSelected();
        this.onShowHideFormSections();
        this.setEvent_submitClicked();
    },

    onShowHideFormSections: function () {
        TPS.SSA.Form.Events.onShowHideFormFields();
    },

    populateStateDropdown: function () {
        var self = this;

        TPS.Util.loadWebserviceJS('CMSApp.AV.API.Program');

        CMSApp.AV.API.Program.AvailableCountries(function (d) {
            jQuery.each(d, function (i, v) {
                jQuery(self.inputs.country).append(jQuery('<option />').attr('value', v.ID).text(v.Name));
            });
        }, TPS.Util.displayError);

        CMSApp.AV.API.Program.AvailableStates(271, function (e) {
            jQuery.each(e, function (i, v) {
                jQuery(self.inputs.state).append(jQuery('<option />').attr('value', v.Id).text(v.Name));
            });
        }, TPS.Util.displayError);

        CMSApp.AV.API.Program.AvailableStates(309, function (e) {
            jQuery.each(e, function (i, v) {
                jQuery(self.inputs.state).append(jQuery('<option />').attr('value', v.Id).text(v.Name));
            });
        }, TPS.Util.displayError);
    },

    setEvent_ReasonSelected: function () {

        var self = this;

        self.eapReasonSelector.addEventListener('change', function (e) {
            e.preventDefault();

            if (e.target.value !== 'other') {

                self.inputs.reason.value = e.target.value;

            } else {
                self.inputs.reason.value = '';
            }

        });

    },

    setEvent_submitClicked: function () {
        var self = this;

        self.btnSubmit.addEventListener('click', function (e) {
            e.preventDefault();

            TPS.Forms.resetMessageBlock('#error-callout');

            if (TPS.Forms.validator.checkForm() && !self.btnSubmit.classList.contains('submitting')) {
                self.setSubmitButtonState(true);
                var vals = TPS.Forms.getFormVals('#eapForm');

                CMSApp.AV.API.Pin.CreateAmbassadorPin(
                    // string firstname, string lastname, string address, string city, string zipcode, int state, int country, string email, string phone, string reason
                    vals.eapFirstName,
                    vals.eapLastName,
                    vals.eapStreetAddress,
                    vals.eapCity,
                    vals.eapZipcode,
                    parseInt(vals.eapState, 10),
                    parseInt(vals.eapCountry, 10),
                    vals.eapEmail,
                    vals.eapPhone,
                    vals.eapReason,
                    success,
                    fail
                );
            }
        });

        function success(data) {
            if (data.Success) {
                self.formSubmittedWrapper.classList.remove('hide');
                self.formWrapper.classList.add('hide');
            } else {
                TPS.Forms.scrollToMessages(data.ErrorMessages, false, '#error-callout', '.hidden-magellan-error', false);
            }
            self.setSubmitButtonState(false);
        }

        function fail(data) {
            console.log(data);
            TPS.Forms.scrollToMessages(data._statusCode + " : " + data._message, true, '#error-callout', '.hidden-magellan-error', true);
            self.setSubmitButtonState(false);
        } 
    },

    setSubmitButtonState: function (isSubmitting) {
        var self = this;

        if (isSubmitting === true) {
            self.btnSubmit.classList.add('submitting');
            self.btnSubmit.innerHTML += TPS.Util.submitSpinner;
            self.btnSubmit.disabled = true;
        } else {
            self.btnSubmit.removeChild(self.btnSubmit.querySelector('.icon'));
            self.btnSubmit.classList.remove('submitting');
            self.btnSubmit.disabled = false;
        }
    }
}
